exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rate-creators-toggle {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin: 10px 0 0 17px; }\n  .rate-creators-toggle .rate-creators-icon {\n    margin-right: 5px; }\n\n.toggle {\n  width: 54px;\n  height: 30px;\n  background-color: #d8d8d8;\n  border-radius: 15px;\n  position: relative;\n  display: inline-block; }\n  .toggle::after {\n    content: '';\n    background-color: white;\n    border-radius: 50%;\n    width: 22px;\n    height: 22px;\n    display: block;\n    position: absolute;\n    left: 4px;\n    top: 4px;\n    transition: left 0.25s; }\n  .toggle.toggle-on {\n    background-color: #2c97de; }\n    .toggle.toggle-on::after {\n      left: 28px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!../scss/toggle.scss
// module id = 3327
// module chunks = 69